import "./svg/fish-2.svg"

export default {
    name: "fish-2",
    viewBox: "0 0 170 120",
}
